var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"w-100 pt-5 pb-5",staticStyle:{"background":"#bfbfbf"}},[_c('h4',{staticClass:"text-center position-relative",staticStyle:{"left":"70%","color":"rgb(84, 101, 54)","width":"max-content"}},[_vm._v(_vm._s(_vm.titulo))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }